module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-afeb71a5e3ca98076c49cafaa098cab6.webp";